import { CheckIcon } from '@heroicons/react/outline';
import React from 'react';

const CheckPoints = () => {
  return (
    <div className='flex flex-col gap-1'>
      <div className='flex items-center gap-2'>
        <CheckIcon className='md:w-6 md:h-6 md:min-w-6 md:min-h-6 min-h-[22px] min-w-[22px] w-[22px] h-[22px] text-success-400' />
        <p className='capitalize text-base font-normal text-white'>
          No auto-renewal without your consent.
        </p>
      </div>
      <div className='flex items-center gap-2'>
        <CheckIcon className='md:w-6 md:h-6 md:min-w-6 md:min-h-6 min-h-[22px] min-w-[22px] w-[22px] h-[22px] text-success-400' />
        <p className='capitalize text-base font-normal text-white'>
          Unlock all app premium features.
        </p>
      </div>
      <div className='flex items-center gap-2'>
        <CheckIcon className='md:w-6 md:h-6 md:min-w-6 md:min-h-6 min-h-[22px] min-w-[22px] w-[22px] h-[22px] text-success-400' />
        <p className='capitalize text-base font-normal text-white'>
          Lifetime access of books
        </p>
      </div>
      <div className='flex items-center gap-2'>
        <CheckIcon className='md:w-6 md:h-6 md:min-w-6 md:min-h-6 min-h-[22px] min-w-[22px] w-[22px] h-[22px] text-success-400' />
        <p className='capitalize text-base font-normal text-white'>
          Access on any device
        </p>
      </div>
    </div>
  );
};

export default CheckPoints;
